module.exports = __webpack_public_path__ + "img/caja-municipal.f48bedfe.svg";